export const NS = {
  common: 'common',
  profile: 'profile',
  dashboard: 'dashboard',
  report: 'report',
};
